/*---------------------------------------------------------------------------------------------
 *  Copyright (c) i-Bridge Systems Philippines Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/
import { GeneralModal, OutlinedButton, ContainedButton } from '../index';
import { Typography, TextField, Grid } from '@mui/material';
import { styled } from '@mui/material/styles';
import { getMessage, getLinks } from '../../utilities/formatMessage';

const DisabledTextField = styled(TextField)({
  '& label.Mui-disabled': {
    color: '#84d8c5',
  },
});

export const ClockInMessageModal = (props) => {
  const messageContent = props.message;
  const message = getMessage(messageContent);
  const links = getLinks(messageContent);

  return (
    <GeneralModal
      style={{ width: '40%', display: 'flex', flexDirection: 'column' }}
      open={props.open}
      onClose={props.onClose}
    >
      <Typography align="center" sx={{ mb: 1, fontWeight: 600 }} variant="h5">
        Clock In Message
      </Typography>
      <DisabledTextField
        disabled
        fullWidth
        label="Subject"
        margin="normal"
        defaultValue={props.subject}
        inputProps={{ style: { WebkitTextFillColor: '#FFF' } }}
      />
      <DisabledTextField
        multiline
        disabled
        fullWidth
        minRows={8}
        label="Message"
        margin="normal"
        defaultValue={message}
        inputProps={{ style: { WebkitTextFillColor: '#FFF' } }}
      />

      {links?.length !== 0 ? (
        <Grid container spacing={2} sx={{ mt: 0 }}>
          {links?.map((link, index) => (
            <Grid key={index} item xs={4}>
              <OutlinedButton
                btnTitle={link[0]}
                href={link[1]}
                target="_blank"
                style={{ width: '100%' }}
              />
            </Grid>
          ))}
        </Grid>
      ) : (
        <></>
      )}
      <Grid container>
        <ContainedButton
          btnTitle="Close"
          onClick={props.onClose}
          style={{ mt: 5, ml: 'auto' }}
        />
      </Grid>
    </GeneralModal>
  );
};
